// pages/TreatmentList.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import RuTable from "../../../RuTable";

const BodyPartTableWrapper = ({ data, handleOpenEdit,handleDeleteConfirm }) => {
  const columns = ["#", "Name", "Active", { name: "Actions", align: "right" }];

  const fields = ["name", { field: "isUsed", align: "center" }];


  return (
    <section className="content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <RuTable
              columns={columns}
              data={data}
              fields={fields}
              renderActions={(item, index) => (
                <div className="d-flex justify-content-end">
                  {item.canUpdate ? (
                    <div
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => handleOpenEdit(item)}
                    >
                      <FaRegEdit />
                    </div>
                  ) : (
                    // <span className="mr-3">_</span>
                    <button
                      disabled
                      className="btn btn-sm btn-warning me-2 opacity-50 "
                    >
                      <FaRegEdit />
                    </button>
                  )}
                  {
                    <button
                      className="btn btn-sm btn-danger me-2"
                      onClick={handleDeleteConfirm.bind(null, item._id)}
                    >
                      <FaRegTrashAlt />
                    </button>
                  }
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BodyPartTableWrapper;
